import Typography from "../Typography/Typography"
import styles from "./style.module.css"
import { ModalClose } from "../../assets/svgs"
import { useEffect } from "react"
// import { OrderItems } from "../orderItems"

interface modalProp {
    id?: string
    openModal?: boolean
    toggle: () => void
    duration?: number
    children?: React.ReactNode
}

export const Toast: React.FC<modalProp> = ({
    id,
    openModal,
    toggle,
    duration = 3000,
    children
}) => {

    useEffect(() => {
        if (openModal && duration) {
            const timer = setTimeout(() => {
                toggle();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [openModal, duration, toggle]);

    if (!openModal) {
        return null
    }

    return (
        <div className={styles.overLay}>

            <div className={styles.container}>

                {/* <button
                    className={styles.close}
                    onClick={() => { toggle() }}
                >
                    <img className={styles.closeModal} src={ModalClose} alt="" />
                </button> */}

                <div className={styles.content}>

                    {/* <div className={styles.reviewContent}> */}

                        {children}

                    {/* </div> */}

                </div>

            </div>

        </div>
    )
}